import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AssessmentCheckBoxGroupSelectComponent } from "./assessment-check-box-group-select.component";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { NzInputModule } from "ng-zorro-antd/input";

@NgModule({
  declarations: [AssessmentCheckBoxGroupSelectComponent],
  imports: [CommonModule, NzCheckboxModule, FormsModule, TranslateModule, NzInputModule],
  exports: [AssessmentCheckBoxGroupSelectComponent],
})
export class AssessmentCheckBoxGroupSelectModule {}
